import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import AnalyticsTracker from "./AnalyticsTracker";

function App() {
    return (
        <BrowserRouter>
            <AnalyticsTracker />
            <AppRoutes />
        </BrowserRouter>
    );
}

export default App;